//angular imports
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';


@Component({
  selector: "list-filter",
  templateUrl: "./list-filter.component.html",
  styleUrl: "./list-filter.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ListFilterComponent {
  public inputValue = input<string>("");
  public clippedSearch = input<boolean>(false);
  public selectable = input<boolean>(false);

  public inFocus: boolean = false;

  public updateFilter = output<any>();

  public searchEntity(event: any) {
    this.updateFilter.emit(event);
  }

  public setFocus(focus: boolean) {
    this.inFocus = focus;
  }
}
